import { OkrKeyResultComment } from "server/models"

export interface OkrKeyResultCommentList { [keyResultId: number]: OkrKeyResultComment[] }

export type OkrKeyResultCommentValidation = { [key in keyof OkrKeyResultComment]?: string}

export interface OkrKeyResultCommentState {
    commentList: OkrKeyResultCommentList
}

export const OKR_KEY_RESULT_COMMENT_LIST = "OKR_KEY_RESULT_COMMENT_LIST"
